import { useEffect, useRef } from 'react';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { UpIcon } from 'foundations-assets/icons/components/UpIcon';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { useUserIndustry } from '../hooks/useUserIndustry';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InteractiveEducationButton = ({
  additionalTracking,
  action,
  display,
  handleClick,
  title,
  use,
  size
}) => {
  const hasTrackedRender = useRef(false);
  const {
    loading: industryLoading
  } = useUserIndustry();
  const shouldWaitForIndustryData = action === 'ai-adapt-to-industry-button-rendered' && industryLoading;
  useEffect(() => {
    if (hasTrackedRender.current || shouldWaitForIndustryData) {
      return;
    }
    hasTrackedRender.current = true;
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, additionalTracking, {
      action
    }));
  }, [action, additionalTracking, shouldWaitForIndustryData]);
  return /*#__PURE__*/_jsxs(AIButton, {
    onClick: handleClick,
    size: size,
    usageTracker: UsageTracker.tracker,
    use: use,
    children: [title, display ? /*#__PURE__*/_jsx(UpIcon, {
      alignWithText: true
    }) : /*#__PURE__*/_jsx(DownIcon, {
      alignWithText: true
    })]
  });
};
export default InteractiveEducationButton;